import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Back, Next, ChatToAFitter } from '../ControlButtons';
import { SizeQuizExampleButton, SizeQuizButton } from '../selects/Buttons';
import { dataLayerGA4SizeQuizStageNumber } from '../../../shared/utils/data-layer';

const Stage10 = ({
  backSize,
  buttonSelected,
  cachedCupSize,
  cupSize,
  defaultButtonProps,
  defaultNextProps,
  defaultPreviousProps,
  intl: { formatMessage, locale },
  messages,
  partTwoButtonSelected,
  resetCup,
  setNextStage,
  setPartTwoSelected,
  setTempCupCache,
  showPartTwo,
  stage10aData,
  stage10bData,
  togglePartTwo,
}) => {
  const STAGE_NUMBER = '10';

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
  }, []);

  return (
    <div className="stageContainer">
      <div className="standardQuestionContainer">
        <Back
          {...defaultPreviousProps(4, formatMessage(messages.restartCupSize))}
          customFunc={() => {
            setPartTwoSelected(0);
            togglePartTwo(false);
            resetCup(cachedCupSize);
            setTempCupCache({ cupSize: cachedCupSize, cupChange: 0 });
          }}
        />
        <div className="stage stage-10">
          <div className="wrap wrap--left">
            <h4>{formatMessage(messages.stage10para1)}</h4>
            <SizeQuizExampleButton
              className="stage__tooltipBtn"
              message={formatMessage(messages.example)}
            />

            <div>
              <div className="buttonsContainer">
                {stage10aData.map(({ func, text }, idx) => (
                  <SizeQuizButton
                    key={idx}
                    {...defaultButtonProps(text, idx, func)}
                  />
                ))}
              </div>

              {showPartTwo && (
                <div>
                  <h4>{formatMessage(messages.stage10para2)}</h4>
                  <span className="highlight">
                    {formatMessage(messages.stage10span1)}
                  </span>
                  <div className="buttonsContainer">
                    {stage10bData.map(({ func, text }, idx) => (
                      <SizeQuizButton
                        key={idx}
                        {...defaultButtonProps(text, idx, func)}
                        partTwoSelected={partTwoButtonSelected}
                        setPartTwoSelected={setPartTwoSelected}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div>
              <Next
                hasChevron
                disabled={
                  showPartTwo ? !partTwoButtonSelected : !buttonSelected
                }
                {...defaultNextProps(1, "Let's find out your bra size")}
                customFunc={() => {
                  setPartTwoSelected(0);
                  togglePartTwo(false);
                  // Check final sizes are within the sold sizes
                  if (
                    cupSize === 'AA' ||
                    cupSize === 'A' ||
                    cupSize === 'B' ||
                    cupSize === 'C' ||
                    backSize >= 44
                  ) {
                    setNextStage(2);
                  }
                }}
                locale={locale}
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="contentDivider" />
      <div id="fittersAdvice" className="contentContainer">
        <h5 className="contentHeader">
          {formatMessage(messages.adviceFromABraFitterHeader)}
        </h5>
        <picture className="c-picture">
          <source
            srcSet="//images.ctfassets.net/bz0fvtkbk5r1/3ayysznFspkRjZ6KrP0QMo/0966b6d3a613ced610048dd058b31573/Wrinkling.jpg?q=80&amp;w=868&amp;fm=webp"
            type="image/webp"
          />
          <img
            alt="Why do my bra cups wrinkle?"
            src="//images.ctfassets.net/bz0fvtkbk5r1/3ayysznFspkRjZ6KrP0QMo/0966b6d3a613ced610048dd058b31573/Wrinkling.jpg?q=80&amp;w=868"
            className="c-image"
          />
        </picture>
        <p className="contentSubHeader">
          {formatMessage(messages.stage10para3)}
        </p>
        <ChatToAFitter stage={STAGE_NUMBER} />
      </div>
    </div>
  );
};

export default injectIntl(Stage10);

Stage10.propTypes = {
  Back: PropTypes.func,
  backSize: PropTypes.string,
  SizeQuizButton: PropTypes.func,
  buttonSelected: PropTypes.number,
  cachedCupSize: PropTypes.string,
  cupSize: PropTypes.string,
  defaultButtonProps: PropTypes.func,
  defaultNextProps: PropTypes.func,
  defaultPreviousProps: PropTypes.func,
  SizeQuizExampleButton: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  partTwoButtonSelected: PropTypes.number,
  resetCup: PropTypes.func,
  setNextStage: PropTypes.func,
  setPartTwoSelected: PropTypes.func,
  setTempCupCache: PropTypes.func,
  showPartTwo: PropTypes.bool,
  stage10aData: PropTypes.array,
  stage10bData: PropTypes.array,
  togglePartTwo: PropTypes.func,
  tooltip: PropTypes.object,
};
